import * as React from 'react';

import Link from '@src/components/link';
import cx from 'classnames';
import $$tracker from '@src/tracker';
import wrapStore from '@src/utils/wrap-store';
import OfficialCommunityStore from '@src/business-components/official-community/store';
const styles = require('./index.less');

const OfficialCommunity = ({ store }) => {
  store.use();

  console.log('store.type', store.type,store.isHideTopMenu);
  const renderOfficialCommunity = () => {
    if (store.type === 'main') {
      return (
        <React.Fragment>
          <div className="main-layer-168" />
          <Link
            className="main-layer-169"
            onClick={() => {
              store.onOfficialModalOpen('官方微博');
              $$tracker.clickWeibo();
            }}
          />
          <Link
            className="main-layer-170"
            onClick={() => {
              store.onOfficialModalOpen('官方抖音');
              $$tracker.clickDouyin();
            }}
          />
          <Link
            className="main-layer-171"
            onClick={() => {
              store.onOfficialModalOpen('企业微信');
              $$tracker.clickQiwei();
            }}
          />
          <Link
            className="main-layer-172"
            onClick={() => {
              store.onOfficialModalOpen('微信公众号');
              $$tracker.clickWeixin();
            }}
          />
        </React.Fragment>
      );
    } else if (store.type === 'other') {
      return (
        <div className={cx(styles.officialCommunity, store.isHideTopMenu && styles.officialCommunityHideTop)}>
          <div className="news-list-layer-47" />
          <Link
            className="news-list-layer-48"
            onClick={() => {
              store.onOfficialModalOpen('微信公众号');
              $$tracker.clickWeixin();
            }}
          />
          <Link
            className="news-list-layer-49"
            onClick={() => {
              store.onOfficialModalOpen('企业微信');
              $$tracker.clickQiwei();
            }}
          />
          <Link
            className="news-list-layer-50"
            onClick={() => {
              store.onOfficialModalOpen('官方抖音');
              $$tracker.clickDouyin();
            }}
          />
          <Link
            className="news-list-layer-51"
            onClick={() => {
              store.onOfficialModalOpen('官方微博');
              $$tracker.clickWeibo();
            }}
          />
        </div>
      );
    } else if (store.type === 'top') {
      return (
        <div className={cx('main-group-60')} data-name="关注icon">
          <div className="main-group-61" data-name="关注icon">
            <Link
              className="main-layer-185"
              onClick={() => {
                store.onOfficialModalOpen('企业微信');
                $$tracker.clickTopNav('关注我们-企业微信');
              }}
            />
            <Link
              className="main-layer-186"
              onClick={() => {
                store.onOfficialModalOpen('微信公众号');
                $$tracker.clickTopNav('关注我们-微信公众号');
              }}
            />
            <Link
              className="main-layer-187"
              onClick={() => {
                store.onOfficialModalOpen('官方微博');
                $$tracker.clickTopNav('关注我们-官方微博');
              }}
            />

            <Link
              className="main-layer-188"
              onClick={() => {
                store.onOfficialModalOpen('官方抖音');
                $$tracker.clickTopNav('关注我们-官方抖音');
              }}
            />
          </div>

          <div className="main-layer-190" />
        </div>
      );
    }
  };
  return <React.Fragment>{renderOfficialCommunity()}</React.Fragment>;
};

export default wrapStore(OfficialCommunity, OfficialCommunityStore);
